<div [ngClass]="isDetailsOutside ? 'calculator-details__outside' : 'calculator-details__inside'">
  <section class="calculate">
    <form [formGroup]="form" class="calculate-wrapper">
      <app-calculate-widget
        (calculateChangeEvent)="calculateChangeHandler($event)"
        [amount]="amount"
        [product]="mockProduct"
        [term]="term"
        formGroupName="calculate"
      ></app-calculate-widget>
      <div class="calculate-container">
        <div class="preview">
          <app-promo-code
            [maxCodeLength]="MIN_CODE_LENGTH"
            [placeholder]="'LOAN.BOOKING.PROMO_PLACEHOLDER' | translate"
            classes="text-left mb-3"
            formControlName="code"
          ></app-promo-code>
          <div class="calculate-button">
            <app-button
              (clickEvent)="navigateToCreditUrl()"
              [label]="'CALCULATE.BTN' | translate"
              class="w-100"
              classes="fs-15"
              color="secondary-gradient"
              size="w100"
              type="button"
            >
            </app-button>
          </div>
          @if (isDetailsOutside) {
          <ng-container [ngTemplateOutlet]="commission_info" />
          }
        </div>
        @if (!isDetailsOutside) {
        <ng-container [ngTemplateOutlet]="calculate_details" />
        }
      </div>
    </form>
    @if (isDetailsOutside) {
    <ng-container [ngTemplateOutlet]="calculate_details" />
    }
  </section>
  @if (!isDetailsOutside) {
  <ng-container [ngTemplateOutlet]="commission_info" />
  }
</div>

<ng-template #commission_info>
  <p
    [innerHTML]=" 'CALCULATE_COMMISSION_INFO' | translate: { first: translateParamsStar.first, second: translateParamsStar.second }  "
    class="calculate-text"
  ></p>
</ng-template>

<ng-template #calculate_details>
  <app-calculate-details [isDetailsOutside]="isDetailsOutside" [preview]="preview$ | async" />
</ng-template>
